import { Injectable } from '@angular/core';

//Import for resolver
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

//Import Obsevable to make service asynchronous
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

import { AuthService } from './services/auth.service';

//Import service

@Injectable()
export class LoginResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any{
    return this.authService.getRoleLogin();
  }
}


// WEBPACK FOOTER //
// ./src/app/app.resolve.ts